var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.964,
    height: 23.857,
    viewBox: "0 0 58.964 23.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MTN_Logo",
    "data-name": "MTN Logo",
    transform: "translate(-1.381 -41.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M24.9,325.9c0-6.2,12.885-11.227,28.78-11.227s28.78,5.028,28.78,11.227-12.885,11.225-28.78,11.225S24.9,332.1,24.9,325.9Z",
    transform: "translate(-22.817 -272.075)",
    fill: "#006891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M24.9,325.9c0-6.2,12.885-11.227,28.78-11.227s28.78,5.028,28.78,11.227-12.885,11.225-28.78,11.225S24.9,332.1,24.9,325.9Z",
    transform: "translate(-22.817 -272.075)",
    fill: "none",
    stroke: "#006891",
    strokeWidth: 1.405
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M199.02,417.16l2.987-11.15h4.715v6.558h.031l3.2-6.558h4.789l-2.987,11.15H208.64l1.915-7.152h-.031l-3.8,7.152h-2.493v-7.152h-.051l-1.915,7.152Z",
    transform: "translate(-186.389 -357.882)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M472.44,569.145l.424-1.585H476.3l-.425,1.585Z",
    transform: "translate(-443.247 -509.646)",
    fill: "#ee4034",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M459.915,415.351l1.738-6.483H458.53l.766-2.858h9.682l-.766,2.858h-3.123l-1.737,6.481Z",
    transform: "translate(-430.179 -357.882)",
    fill: "#ffc325",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M594.36,417.16l2.985-11.15h3.374l1.522,5.966h.03l1.6-5.966h3.119L604,417.16h-3.21l-1.653-6.09h-.03l-1.631,6.09Z",
    transform: "translate(-557.781 -357.882)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtn);
export default __webpack_public_path__ + "static/media/MTN.e9318d15c026b52d0494271f3d431e75.svg";
export { ForwardRef as ReactComponent };